<template>
    <div class="order-complete">
        <div class="container has-text-left">
            <div class="hero is-large">
                <div class="hero-body">
                    <div class="container">
                        <h1 class="title is-2 has-text-grey">
                            Die Bestellung wurde abgebrochen.
                        </h1>
                    </div>
                    <div class="container">
                        <a @click="goToStart()" class="is-size-3"
                            >Zurück zur Startseite</a
                        >
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { orderProcess } from '../../store/constants/order-process';

export default {
    name: 'OrderFailed',
    methods: {
        goToStart() {
            this.$router.push('/');
        },
        fetchCMSData() {
            this.$store.dispatch('fetchCMSPage', { urlSlug: '/' });
        },
    },
    created() {
        this.fetchCMSData();
        this.$store.dispatch(
            'setCurrentOrderProcessStep',
            orderProcess.STEPS.ORDER_COMPLETED
        );
        if (this.$route.query.token) {
            this.$store.dispatch('handlePayPalCallback', {
                ...this.$route.query,
                success: false,
            });
        }
    },
};
</script>

<style scoped></style>
